module.exports = __webpack_public_path__ + "pc/static/img/fid2.6addbbb2.png";